module.exports = __webpack_public_path__ + "static/media/DreamHouseLogo2.5ef439fd.PNG";